import { useLayoutEffect } from "react";
import { useSetStyleEditorView } from "../../../hooks/style";

export function MapSources() {
  const setStyleEditorView = useSetStyleEditorView();

  useLayoutEffect(() => {
    setStyleEditorView("sources");
  }, [setStyleEditorView]);

  return null;
}
